const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

const isPlainObject = value => (
    value !== null
    && typeof value === 'object'
    && !Array.isArray(value)
)

export const argumentDescriptors = schema => (
    schema && Array.isArray(schema.arguments) ? schema.arguments : []
)

export const initialArguments = schema => argumentDescriptors(schema)
    .reduce((result, argument) => {
        if (argument.hasDefaultValue) {
            result[argument.name] = argument.defaultValue
        }
        return result
    }, {})

export const validateArgument = (argument, values = {}) => {
    const present = hasOwn(values, argument.name)

    if (!present) {
        return argument.required ? 'This argument is required.' : null
    }

    const value = values[argument.name]
    if (value === null) {
        return argument.nullable ? null : 'Null is not allowed.'
    }

    if (Array.isArray(argument.allowedValues)
        && argument.allowedValues.length
        && !argument.allowedValues.some(allowedValue => allowedValue === value)) {
        return 'Choose one of the allowed values.'
    }

    switch (argument.type) {
    case 'string':
        return typeof value === 'string' ? null : 'Enter a text value.'
    case 'integer':
        return Number.isInteger(value) ? null : 'Enter a whole number.'
    case 'number':
        return typeof value === 'number' && Number.isFinite(value)
            ? null
            : 'Enter a valid number.'
    case 'boolean':
        return typeof value === 'boolean' ? null : 'Choose true or false.'
    case 'string_list':
        return Array.isArray(value) && value.every(item => typeof item === 'string')
            ? null
            : 'Enter a list of text values.'
    case 'map':
    case 'object':
        return isPlainObject(value) ? null : 'Enter a valid JSON object.'
    default:
        return null
    }
}

export const argumentIssues = (schema, values = {}) => argumentDescriptors(schema)
    .map(argument => ({
        argument,
        message: validateArgument(argument, values),
    }))
    .filter(issue => issue.message)

